import type { ReactNode } from "react";

import { classes } from "./classes.js";

/**
 * `P0-UIK-001`: a label, its control, and the two things a form must be able
 * to say , a hint before the mistake and an error after it.
 *
 * The error is rendered in `rose-600`, 4.6.3's alert text, and it is rendered
 * BESIDE the control rather than in a toast: a message that disappears is a
 * message a client on a 3G connection did not read.
 */
export interface FieldProps {
  readonly label: ReactNode;
  readonly htmlFor: string;
  readonly children: ReactNode;
  readonly hint?: ReactNode;
  readonly error?: ReactNode;
  readonly className?: string;
}

export function Field({ label, htmlFor, children, hint, error, className }: FieldProps): React.JSX.Element {
  return (
    <div className={classes("flex flex-col gap-2", className)}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-gray-900">
        {label}
      </label>
      {children}
      {hint === undefined ? null : <span className="text-xs text-gray-500">{hint}</span>}
      {error === undefined ? null : (
        <span role="alert" className="text-xs text-rose-600">
          {error}
        </span>
      )}
    </div>
  );
}
